import { Box } from "@mui/material"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC } from "react"
import { useRef } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { PriceChangeRecipient } from "@/graphql/codegen/graphql"
import { usePriceChangeRecipientsColumns } from "@/screens/Pricing/hooks/usePriceChangeRecipientsColumns"

interface ViewRecipientsTableProps {
  data?: PriceChangeRecipient[]
  isLoading?: boolean
}

const ViewRecipientsTable: FC<ViewRecipientsTableProps> = ({ data, isLoading }) => {
  const tableContainerRef = useRef<HTMLDivElement>(null)

  const columns = usePriceChangeRecipientsColumns()

  return (
    <Box className='flex h-full flex-col'>
      <AerosBaseTable
        features={{
          table: {
            stickyHeader: true,
          },
          tanstackOptions: {
            data: data ?? [],
            state: {
              isLoading: isLoading,
            },
            columns,
            getCoreRowModel: getCoreRowModel(),
          },
        }}
        slotProps={{
          container: {
            ref: tableContainerRef,
          },
          bodyRow: {
            className: "hover:bg-primary-100",
          },
        }}
        noDataMessage='No data found'
      />
    </Box>
  )
}

export default ViewRecipientsTable
